import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=acf91e5c&scoped=true&"
import script from "./CommentsModal.vue?vue&type=script&lang=js&"
export * from "./CommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentsModal.vue?vue&type=style&index=0&id=acf91e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf91e5c",
  null
  
)

export default component.exports